import * as React from 'react';
import { Outlet, Link } from "react-router-dom";
import Footer from "./Footer";
import logo from '../assets/vineyardLogo.png'
import {Box, ListItem, Stack} from "@mui/joy";
import './styles/navigator.css'
import NavigationMenu from "./NavigationMenu";
import ContactModal from './ContactModal';
import GiveModal from './GiveModal';

const Navigator = () => {
    return (
        <Box className='navigator-bar'>
            <Stack direction='row' sx={{justifyContent: 'space-between'}}>
                <Stack direction='row' className='navigator-content'>
                    <Link className='link' to="/"><img className='nav-image' src={logo} alt='logo'/></Link>
                    <ListItem>
                        <Link className='link-alt' to="/leaders">Who We Are</Link>
                    </ListItem>
                    <ListItem>
                        <Link className='link-alt' to="/beliefs">Beliefs</Link>
                    </ListItem>
                    <ListItem>
                        <Link className='link-alt' to="/ministries">Ministries</Link>
                    </ListItem>
                    <ListItem>
                        <Link className='link-alt' to="/sermons">Sermons</Link>
                    </ListItem>
                    <ListItem>
                        <Link className='link-alt' to="/join">Plan A Visit</Link>
                    </ListItem>
                    <ListItem>
                        <GiveModal linkClass='link-alt' text='Give'/>
                    </ListItem>
                    <ListItem>
                        <ContactModal linkClass='link-alt' text='Contact'/>
                    </ListItem>
                    {/* <NavigationMenu/> */}
                </Stack>
            </Stack>
            <Outlet/>
            <Footer/>
        </Box>
    )
};

export default Navigator;
